import React from 'react';
import InPageOverlay from 'components/InPageOverlay/InPageOverlay';
import ThumbnailSlider from './ThumbnailSlider';
import {get, clone} from 'lodash';
import ImageGalleryImage from './ImageGalleryImage';
import {GalleryWrapper} from './ImageGallery.styles.js'


class ImageGallery extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      activeImageIndex: 0
    };
  }

  shouldComponentUpdate(nextProps) {
    if (!nextProps.images && this.props.images) {
      return false;
    } else {
      return true;
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (get(nextProps, 'images[0]', null) !== get(this.props, 'images[0]', null)) {
      this.setState({activeImageIndex: 0});
    }
    if (get(nextProps, 'activeImageIndex', null) !== get(this.props, 'activeImageIndex', null)) {
      this.setState({activeImageIndex: nextProps.activeImageIndex});
    }

    if (nextProps.patch && !this.state.patch && nextProps.images) {
      this.setState({image: nextProps.images[0]})
    }
  }

  UNSAFE_componentWillMount() {
    this.setState({activeImageIndex: this.props.activeImageIndex || 0});
  }

  componentDidMount() {
    if (this.props.keyDownEvents) {
      this.bindedKeyDown = this.onKeyDown.bind(this);
      document.addEventListener('keydown', this.bindedKeyDown);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.bindedKeyDown);
  }

  onKeyDown(e) {
    const images = this.props.images || [];
    if (images.length) {
      if (e.which === 37 && this.state.activeImageIndex > 0) { // left
        e.preventDefault();
        this.setState({activeImageIndex: this.state.activeImageIndex - 1});
      } else if (e.which === 39 && this.state.activeImageIndex < images.length - 1) { // right arrow
        e.preventDefault();
        this.setState({activeImageIndex: this.state.activeImageIndex + 1});
      }
    }
  }


  render() {
    const images = clone(this.props.images) || [];
    if (this.state.image && images.length) {
      images[0] = this.state.image;
    }
    const gallery = this.renderImages(images);
    return (
      <GalleryWrapper>
        {gallery}
      </GalleryWrapper>
    );
  }

  onClickProductImage(images, activeImageIndex) {
    this.setState({inPageOverlayViewOpen: true})
  }

  renderImages(imageSet) {
    let activeImage = imageSet[this.state.activeImageIndex];
    return (
      <div>
        <ImageGalleryImage pointer={true} key={'1'} onClick={this.onClickProductImage.bind(this, imageSet, this.state.activeImageIndex)} image={activeImage}/>
        <ThumbnailSlider limit={4} onExpand={this.onClickProductImage.bind(this, imageSet, this.state.activeImageIndex)} onImageClicked={this.onThumbnailClicked.bind(this)} activeImageIndex={this.state.activeImageIndex} images={imageSet}/>

        <InPageOverlay closeOnEsc={true} portal={true} disableScroll={true} showClose={true} onClose={() => this.setState({inPageOverlayViewOpen: false})} open={this.state.inPageOverlayViewOpen}>
          <div style={{padding: '30px 30px 30px 30px', display: 'flex', justifyContent: 'center'}}>
            <div>
              <ImageGalleryImage fullScreen={true} onClick={this.onClickProductImage.bind(this, imageSet, this.state.activeImageIndex)} image={activeImage}/>
              <ThumbnailSlider large={true} onImageClicked={this.onThumbnailClicked.bind(this)} activeImageIndex={this.state.activeImageIndex} images={imageSet}/>
            </div>
          </div>
        </InPageOverlay>
      </div>
    );
  }

  onThumbnailClicked(activeImageIndex, url) {
    this.setState({activeImageIndex});
  }
}


export default ImageGallery;